module.exports = __webpack_public_path__ + "img/62.89650b9c.png";